
export const SELECT_ACTIVITY_ID = 'SELECT_ACTIVITY_ID'
export const INVALIDATE_ACTIVITY_ID = 'INVALIDATE_ACTIVITY_ID'
export const REQUEST_CPS = 'REQUEST_CPS'
export const RECEIVE_CPS = 'RECEIVE_CPS'


export const CHECK_PERMISSIONS = 'CHECK_PERMISSIONS'

export function checkPermissions() {
    return (dispatch,getState) => {
        const username = getState().updatedUsername
        const password = getState().updatedPassword
        let permissions =  (username === 'eei@aai.com' && password === 'Ap_ple2')
        // permissions =  (true) //debug
        ? ['Assessments'] : ['Error']
        dispatch( {type:CHECK_PERMISSIONS,permissions})
    }
}


export function selectActivityId(activityId) {
    return {
        type: SELECT_ACTIVITY_ID,
        activityId
    }
}
export function invalidateActivityId(activityId) {
    return {
        type: INVALIDATE_ACTIVITY_ID,
        activityId
    }
}

function requestCps(activityId) {
    return {
        type: REQUEST_CPS,
        activityId
    }
}

function receiveCps(activityId, cps) {
  return {
    type: RECEIVE_CPS,
    activityId,
    cps,
    receivedAt: Date.now()
  }
}

export function populateCpsReferences(activityId,store) {
    return dispatch => {
        dispatch(requestCps(activityId))
        
        return store.firestore.get('activities/'+activityId).then(snapshot =>  
            {
                let promises = []
                snapshot.data()
                    .competencies.map( (cpDocRef,i) => {
                            console.log(cpDocRef.id)
                            return promises.push(cpDocRef.get().then(snapshot => { 
                                let data = snapshot.data()
                                data.id = cpDocRef.id
                                return data 
                            }) ) 
                        }
                    )
                return Promise.all(promises).then( values => 
                    { 
                        values.map( value => console.log(value))
                        dispatch(receiveCps(activityId,values))
                    }
                )
        
            }

        )

    }
}


function shouldPopulateCps(state, activityId) {
  const cps = state.cpsByActivityId[activityId]
  if (!cps) {
    return true
  } else if (cps.isFetching) {
    return false
  } else {
    return cps.didInvalidate
  }
}


export function populateCpsIfNeeded(activityId,store) {
  return (dispatch, getState) => {
    if (shouldPopulateCps(getState(), activityId)) {
      return dispatch(populateCpsReferences(activityId,store))
    }
  }
}



// WEBPACK FOOTER //
// ./src/examples/firestore/actions.js